import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

interface StyledButtonHalfProps {
  theme: any;
  $borderWidth: string;
  $borderRadius: string;
}
export const StyledButtonHalf = styled.a<StyledButtonHalfProps>`
  display: block;
  background-size: cover;
  background-position: center center;
  text-align: ${({ theme }) => (theme.button_half_align_label_left && 'left') || 'center'};
  margin: 0 auto ${pxToRem(10)} auto;
  border-radius: ${({ $borderRadius }) => $borderRadius}%;
  border: ${({ $borderWidth }) => $borderWidth}px solid
  ${({ theme }) => theme.button_half_border_color || 'black'};
  width: 100%;

  &::after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  ${({ theme }) => theme.custom_button_half && theme.custom_button_half}
`

interface StyledAsButtonProps {
  theme: any;
  $borderWidth: string;
  $borderRadius: string;
}
export const StyledAsButton = styled.button<StyledAsButtonProps>`
  display: block;
  background-size: cover;
  background-position: center center;
  text-align: ${({ theme }) => (theme.button_half_align_label_left && 'left') || 'center'};
  margin: 0 auto ${pxToRem(10)} auto;
  border-radius: ${({ $borderRadius }) => $borderRadius}%;
  border: ${({ $borderWidth }) => $borderWidth}px solid
  ${({ theme }) => theme.button_half_border_color || 'black'};
  width: 100%;

  &::after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  ${({ theme }) => theme.custom_button_half && theme.custom_button_half}
`

interface StyledHalfContainerProps {
  theme: any;
}
export const StyledHalfContainer = styled.div<StyledHalfContainerProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: ${pxToRem(20)};

  a:last-of-type::before {
    content: '';
    display: block;
    margin-bottom: ${pxToRem(10)};
    ${({ theme }) =>
            theme.button_half_underline &&
            `border-bottom: ${pxToRem(theme.button_half_underline_height || 1)} solid ${
                    theme.button_half_underline_color || 'black'
            }`};
    ${({ theme }) =>
            theme.button_half_underline_width && `width: ${pxToRem(theme.button_half_underline_width)}`};
  }
`

const getFlex = (columns) => {
  switch (columns) {
    case '3':
      return '33%'
    case '4':
      return '25%'
    case '7':
      return '14%'
    default:
      return '43%'
  }
}

const getFontSize = (columns) => {
  switch (columns) {
    case '3':
      return pxToRem(13)
    case '4':
      return pxToRem(12)
    default:
      return pxToRem(15)
  }
}

interface StyledContainerItemProps {
  theme: any;
  $columns: string;
}
export const StyledContainerItem = styled.div<StyledContainerItemProps>`
  position: relative;
  flex-basis: ${({ $columns }) => getFlex($columns)};
  max-width: ${({ $columns, theme }) =>
          (theme.button_half_max_width && pxToRem(theme.button_half_max_width)) || getFlex($columns)};
  padding: ${pxToRem(10)};
  text-align: ${({ theme }) => (theme.button_half_align_label_left && 'left') || 'center'};

  span {
    ${({ theme }) => theme.button_half_font && `font-family: ${theme.button_half_font}`};
    font-weight: ${({ theme }) => theme.button_half_text_weight || '600'};
    font-size: ${({ $columns, theme }) =>
            theme.button_half_resize_label ? getFontSize($columns) : pxToRem(theme.button_half_text_size || 15)};
    word-break: break-word;
    ${({ $columns }) =>
      $columns === '7' &&
      `font-size: ${pxToRem(12)};
      display: block;
      margin-left: -${pxToRem(9)};
      margin-right: -${pxToRem(9)};
      padding-left: 1px; 
      padding-right: 1px; 
      `}
    ${({ theme }) => theme.button_half_text_color && `color: ${theme.button_half_text_color}`};
  }

  ${({ theme }) => theme.custom_button_half_container && theme.custom_button_half_container}
`
